// Configuração central do app.
export const STORAGE_VERSION = "1.0.0";
export const APP_NOME = "Ficha Socioeconômica";
